import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5862bd3c")

_pushScopeId("data-v-5862bd3c")
const _hoisted_1 = { class: "notfound" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"comment\" data-v-5862bd3c><p class=\"-royalBlue -bold\" data-v-5862bd3c>ERROR</p><span class=\"-medium\" data-v-5862bd3c>Sorry, the page not found</span></div><div class=\"bg\" data-v-5862bd3c><div class=\"ellipse1\" data-v-5862bd3c></div><div class=\"ellipse2\" data-v-5862bd3c></div><div class=\"ellipse3\" data-v-5862bd3c></div><div class=\"ellipse4\" data-v-5862bd3c></div><div class=\"ellipse5\" data-v-5862bd3c></div><div class=\"ellipse6\" data-v-5862bd3c></div><div class=\"ellipse7\" data-v-5862bd3c></div><div class=\"ellipse8\" data-v-5862bd3c></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_noneFooter = _resolveDirective("noneFooter")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _hoisted_2
  ], 512)), [
    [_directive_noneFooter]
  ])
})